import { ValidationCallback } from "validation/validate";

import {
	MentorProductBase,
	flagValidationErrorsInMentorProductBase
} from "types-and-validators/MentorProductBase";
import { MentorProductSettings } from "types-and-validators/MentorProductSettings";

export type MentorProduct = MentorProductBase & MentorProductSettings;

export const flagValidationErrorsInMentorProduct: ValidationCallback<
	MentorProduct
> = (input, utils, auth) => {
	const { flag, checkField } = utils;

	flagValidationErrorsInMentorProductBase(input, utils, auth);

	checkField("isEnabled", { type: "boolean" });
	checkField("series", { type: "string" });

	// Not using checkField to check guestUid because "null" is a meaningful value, and checkField does not support string-or-null
	if (input.guestUid && typeof input.guestUid !== "string") {
		flag("guestUid", "not a string or null");
	}
};
